<template>
  <div>
    <!-- 배송비 설정 컴포넌트 -->
    <div class="columns is-multiline">
      <!-- pack은 배송 상품 등록 페이지이며 이를 제외한 관리자가 상품을 등록할 경우 설정 가능 -->
      <div class="column is-full" v-if="pack!=='delivery'">
        <div v-if="isAdmin">
          <lp-radio :val="type"
                    value_name="value"
                    label_name="label"
                    @onSelect="selectBurdenType"
                    :data="burdenTypeArr"></lp-radio>
        </div>
        <div v-else>
          <div v-if="type===0">플랫폼 부담</div>
          <div v-else-if="type===2">파트너 부담</div>
        </div>
      </div>
      <!-- 관리자가 플랫폼 부담일 경우 또는 파트너가 파트너 부담일 경우 -->
      <div class="column is-full">
        <admin-form-item label="배송비 조건 선택*" tip="배송비 조건 관리 메뉴에서 배송비를 등록할 수 있습니다.">
                  <span class="select">
                    <select v-model="id"
                            :disabled="calcDisabled"
                            @change="selectDeliveryPrice">
                      <option value="" disabled selected>선택</option>
                      <option :value="item.id"
                              v-for="(item, item_idx) in deliveryPriceArr" :key="`delivery-${item_idx}`"
                      >{{ item.name }}</option>
                    </select>
                  </span>
        </admin-form-item>
      </div>
    </div>
  </div>
</template>

<script>
  import LpRadio from "./LpRadio";

  export default {
    components: {LpRadio},
    name: "lp-prod-delivery-price",
    props: {
      burden_type: {
        type: Number
      },
      delivery_price_id: {
        type: Number
      },
      pack: {
        type: String
      },
      partner_id: {
        type: Number,
        required:false
      },
      product: {
        type: Object
      }
    },
    data() {
      return {
        // 부담 유형
        type: 0,
        id: 0,
        // 배송지 조건 목록
        deliveryPriceArr: [],
        burdenTypeArr: []
      }
    },
    created() {
      if(this.burden_type) this.type = this.burden_type;
      if(this.delivery_price_id) this.id = this.delivery_price_id;
      this.initPage();
      this.addBurdenType();
    },
    watch: {
      burden_type(n) {
        this.type = n;
      },
      delivery_price_id(n) {
        this.id = n;
      },
      partner_id(n) {
        this.selectBurdenType(this.burden_type);
        this.addBurdenType();
      }
    },
    computed: {
      calcDisabled() {
        if(this.type===0 && this.isAdmin || this.type===2 && !this.isAdmin) {
          return false;
        }
        else return true;
      }
    },
    methods: {
      addBurdenType() {
        // 슈퍼바이저 예외처리
        if(!this.product.is_super_visor && this.partner_id) {
          this.burdenTypeArr = [{label:'플랫폼 부담',value:0},{label:'파트너 부담',value:2}]
        } else if(this.product.is_super_visor) {
          this.burdenTypeArr = [{label:'플랫폼 부담',value:0}]
        } else {
          this.burdenTypeArr = [{label:'플랫폼 부담',value:0}]
        }
      },
      initPage() {
        // 수정 페이지
        if(this.$route.query.id) {
          this.selectBurdenType(this.burden_type);
        }
        // 등록 페이지
        else {
          if(this.isAdmin) {
            this.selectBurdenType(0);
          }
          else {
            this.selectBurdenType(2);
          }
        }
      },
      getAdminDeliveryPriceBase(burden_type) {
        if(this.$route.query.id) {
          return;
        }
        let query = '';
        if(burden_type===0) query = `?partner_null=true`;
        else if(burden_type===2) query = `?partner_id=${this.partner_id}`;
        this.$axios.get(this.getUrl(`product/deliveryprice/base${query}`)).then(res=> {
          if(res.data.length>0) {
            this.id = res.data[0].id;
          } else {
            this.id = this.deliveryPriceArr[0].id;
          }
          this.$emit('update:delivery_price_id', this.id);
        })
      },
      // 기본 배송지 조건 가져와서 저장
      getPartnerDeliveryPriceBase() {
        if(this.$route.query.id) {
          return;
        }
        this.$axios.get(this.getUrl(`product/deliveryprice/base`)).then(res=> {
          if(res.data.length>0) {
            this.id = res.data[0].id;
          } else {
            this.id = this.deliveryPriceArr[0].id;
          }
          this.$emit('update:delivery_price_id', this.id);
        })
      },
      // 기본 배송지 조건 가져와서 저장
      getPublicDeliveryPriceBase() {
        if(this.$route.query.id) {
          return;
        }
        this.$axios.get(`public/product/deliveryprice/base`).then(res=> {
          this.id = res.data.id;
          this.$emit('update:delivery_price_id', this.id);
        })
      },
      getAdminDeliveryPriceList(burden_type) {
        let query = '';
        if(burden_type===0) query = `?partner_null=true`;
        else if(burden_type===2) query = `?partner_id=${this.partner_id}`;
        this.$axios.get(this.getUrl(`product/deliveryprice/simple${query}`)).then(res=> {
          this.deliveryPriceArr = res.data;
        })
      },
      getPartnerDeliveryPriceList() {
        this.$axios.get(this.getUrl(`product/deliveryprice/simple`)).then(res=> {
          this.deliveryPriceArr = res.data;
        })
      },
      getPublicDeliveryPriceList() {
        this.$axios.get(`public/product/deliveryprice`).then(res=> {
          this.deliveryPriceArr = res.data;
        })
      },
      // 할인 부담 유형 선택( 0: 플랫폼, 2: 파트너)
      async selectBurdenType(val) {
        this.type = val;
        this.$emit('update:burden_type', this.type);
        // 관리자 부담 유형
        if(val===0) {
          if(this.$store.getters.mode==='supervisor') {
            await this.getPublicDeliveryPriceList();
            await this.getPublicDeliveryPriceBase();
          } else {
            await this.getAdminDeliveryPriceList(val);
            await this.getAdminDeliveryPriceBase(val);
          }
        }
        else if(val===2) {
          if(this.isAdmin) {
            await this.getAdminDeliveryPriceList(val);
            await this.getAdminDeliveryPriceBase(val);
          }
          else {
            await this.getPartnerDeliveryPriceList();
            await this.getPartnerDeliveryPriceBase();
          }
        }
      },
      // 배송비 조건 선택
      selectDeliveryPrice(e) {
        this.id = parseInt(e.target.value);
        this.$emit('update:delivery_price_id', this.id);
      }
    }
  }
</script>

<style scoped>

</style>
